import type { Directive } from 'vue'

interface HTMLElementWithClickOutside extends HTMLElement {
  clickOutsideEvent?(event: MouseEvent): void
}

export const clickOutside: Directive<HTMLElementWithClickOutside> = {
  mounted: (el, { value }) => {
    el.clickOutsideEvent = (evt) => {
      if (!(el == evt.target || el.contains(evt.target as HTMLElement))) {
        if (value) {
          value()
        }
      }
    }
    document.addEventListener('mousedown', el.clickOutsideEvent)
  },
  unmounted: (el) => {
    if (el.clickOutsideEvent) {
      document.removeEventListener('mousedown', el.clickOutsideEvent)
    }
  }
}
